/* 曹操傳・第 1 章：汴水（滎陽附近，190 年）
 * 曹操從東邊的酸棗西進追董卓，大路穿過一片丘陵（徐榮的伏兵在南北兩側）。東邊是汴水，南北流向，要回酸棗得找船渡河。 */
export const AMBUSH = [3600, 2500], RIVER_X = 6500, BANKS = [[6020, 1300], [6060, 2500], [6000, 3700]];
export default {
  id: 'bianshui', name: '汴水', W: 8400, H: 5000, seed: 1901,
  bases: [[7800, 2500], [800, 2500]], // 酸棗（東岸）、滎陽方向
  rivers: [{ pts: [[RIVER_X, -100], [RIVER_X - 150, 1500], [RIVER_X + 100, 3000], [RIVER_X - 100, 5100]], hw: 260, fords: [] }],
  roads: [{ pts: [[800, 2500], [2400, 2450], [3600, 2500], [4800, 2550], [5900, 2500]], w: 150 }, { pts: [[7000, 2500], [7800, 2500]], w: 140 }],
  rocks: [[3400, 1500, 520, 260], [3600, 3500, 520, 260], [2000, 1200, 360, 180], [2100, 3800, 360, 180], [5000, 1200, 360, 180], [5100, 3900, 380, 180]],
  woods: 0.5,
  sight: 0.6,
  clearings: [[AMBUSH[0], AMBUSH[1], 520], ...BANKS.map(([x, y]) => [x - 150, y, 260])],
  tents: [{ x: 7800, y: 2500, n: 5, r: 360, col: '#3b5a99', flag: '曹' }],
  grass: [[3000, 2000, 260, 120], [4200, 3000, 260, 120], [5300, 2000, 240, 110], [5400, 3200, 240, 110], [5800, 1800, 200, 90]],
};
